import { Modal } from "antd";

export default function UnsavedChangesModal({ blocker }) {
  return (
    <Modal
      open={blocker.state === "blocked"}
      title="Leave this page?"
      okText="Leave page"
      cancelText="Stay on page"
      okButtonProps={{ danger: true }}
      onOk={() => blocker.proceed?.()}
      onCancel={() => blocker.reset?.()}
    >
      You have unsaved changes. If you leave now, your changes will be lost.
    </Modal>
  );
}
